import { useState, useRef, useCallback } from 'react';
import { INITIAL_MESSAGE } from '../chatConstants';

/**
 * Conversation state and history helpers for the AI chat.
 */
export function useConversation() {
    const [messages, setMessages] = useState([INITIAL_MESSAGE]);
    const [currentPhase, setCurrentPhase] = useState('intent');
    const [pendingWidgetId, setPendingWidgetId] = useState(null);
    const pendingWidgetIdRef = useRef(null);

    const getRecentHistory = useCallback((messagesList, count = 5) => {
        const all = (messagesList ?? []).filter((m) => m.id !== 'initial');
        return all.slice(-count).map((m) => ({ role: m.role, content: m.content }));
    }, []);

    const getFullHistory = useCallback((messagesList) => {
        return (messagesList ?? [])
            .filter((m) => m.id !== 'initial')
            .map((m) => ({ role: m.role, content: m.content }));
    }, []);

    const hasEditKeywords = useCallback((message) => {
        const editKeywords = ['edit', 'change', 'update', 'modify', 'rename', 'adjust', 'set', 'alter'];
        const lowerMessage = (message || '').toLowerCase();
        return editKeywords.some((keyword) => lowerMessage.includes(keyword));
    }, []);

    return {
        messages,
        setMessages,
        currentPhase,
        setCurrentPhase,
        pendingWidgetId,
        setPendingWidgetId,
        pendingWidgetIdRef,
        getRecentHistory,
        getFullHistory,
        hasEditKeywords,
    };
}
